export const DEFAULT_USER_DISPLAY_NAME = 'Пользователь';
